import { BaseDataLayer, DataLayerPlanType, PLAN_CODE_MAP, SALE_WITH_AGENT_MAP } from './base';

type ValidationErrorActionType = 'Volver' | 'Intentar de Nuevo';

const baseEventParams = {
  page: '/deceso/validacion-identidad/error',
  page_title: 'Deceso - Error Validacion de Identidad',
  product: 'Seguro Deceso',
  view_type: 'web',
};

const validationErrorPageViewDataLayer = (
  plan: DataLayerPlanType,
  insured: string,
  withAgent: boolean
) => ({
  ...baseEventParams,
  action_type: 'Pageview',
  product_type: plan,
  asegurados: insured,
  venta_asistida: SALE_WITH_AGENT_MAP[withAgent.toString()],
});

const retryOrGoBackClickDataLayer = (
  plan: DataLayerPlanType,
  insured: string,
  action: ValidationErrorActionType
) => ({
  ...baseEventParams,
  action_type: 'click',
  action: `Click - ${action}`,
  product_type: plan,
  asegurados: insured,
});

export const validationErrorPageView = (planCode: string, insured: number, withAgent: boolean) =>
  BaseDataLayer({
    eventParams: validationErrorPageViewDataLayer(
      PLAN_CODE_MAP[planCode],
      insured.toString(),
      withAgent
    ),
  });

export const validationErrorRetryOrGoBackClick = (
  planCode: string,
  insured: number,
  action: ValidationErrorActionType
) =>
  BaseDataLayer({
    eventParams: retryOrGoBackClickDataLayer(PLAN_CODE_MAP[planCode], insured.toString(), action),
  });
